export default __webpack_public_path__ + "static/media/Kenzielog.83d97bc1.png";